<template>
  <div>
    <!-- Search Area Starts -->
    <div class="search-area">
      <div class="search-bg">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <form action="#" class="d-md-flex justify-content-between">
                <select>
                  <option value="1">All Category</option>
                  <option value="2">Part Time</option>
                  <option value="3">Full Time</option>
                  <option value="4">Remote</option>
                  <option value="5">Office Job</option>
                </select>
                <select>
                  <option value="1">Select Location</option>
                  <option value="2">Dhaka</option>
                  <option value="3">Rajshahi</option>
                  <option value="4">Barishal</option>
                  <option value="5">Noakhali</option>
                </select>
                <input type="text" placeholder="Search Keyword" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Search Keyword'" required>
                <button type="submit" class="template-btn">find job</button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center mt-5">
            <span>49 Results found for “Telecommunication”</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Search Area End -->


    <!-- Jobs Area Starts -->
    <section class="jobs-area section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="single-job mb-4 d-lg-flex justify-content-between">
              <div class="job-text">
                <h4>Assistant Executive - Production/ Quality Control</h4>
                <ul class="mt-4">
                  <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>
                  <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>
                  <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>
                </ul>
              </div>
              <div class="job-img align-self-center">
                <img src="static/assets/images/job1.png" alt="job">
              </div>
              <div class="job-btn align-self-center">
                <a href="#" class="third-btn job-btn1">full time</a>
                <a href="#" class="third-btn">apply</a>
              </div>
            </div>
            <div class="single-job mb-4 d-lg-flex justify-content-between">
              <div class="job-text">
                <h4>Asst. Manager, Production (Woven Dyeing)</h4>
                <ul class="mt-4">
                  <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>
                  <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>
                  <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>
                </ul>
              </div>
              <div class="job-img align-self-center">
                <img src="static/assets/images/job2.png" alt="job">
              </div>
              <div class="job-btn align-self-center">
                <a href="#" class="third-btn job-btn2">full time</a>
                <a href="#" class="third-btn">apply</a>
              </div>
            </div>
            <div class="single-job mb-4 d-lg-flex justify-content-between">
              <div class="job-text">
                <h4>Deputy Manager/ Assistant Manager - Footwear</h4>
                <ul class="mt-4">
                  <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>
                  <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>
                  <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>
                </ul>
              </div>
              <div class="job-img align-self-center">
                <img src="static/assets/images/job3.png" alt="job">
              </div>
              <div class="job-btn align-self-center">
                <a href="#" class="third-btn job-btn3">full time</a>
                <a href="#" class="third-btn">apply</a>
              </div>
            </div>
            <div class="single-job mb-4 d-lg-flex justify-content-between">
              <div class="job-text">
                <h4>R&D Manager (Technical Lab Department)</h4>
                <ul class="mt-4">
                  <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>
                  <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>
                  <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>
                </ul>
              </div>
              <div class="job-img align-self-center">
                <img src="static/assets/images/job4.png" alt="job">
              </div>
              <div class="job-btn align-self-center">
                <a href="#" class="third-btn job-btn4">full time</a>
                <a href="#" class="third-btn">apply</a>
              </div>
            </div>
            <div class="single-job d-lg-flex justify-content-between">
              <div class="job-text">
                <h4>Manager/ Asst. Manager (Quality Assurance)</h4>
                <ul class="mt-4">
                  <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>
                  <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>
                  <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>
                </ul>
              </div>
              <div class="job-img align-self-center">
                <img src="static/assets/images/job5.png" alt="job">
              </div>
              <div class="job-btn align-self-center">
                <a href="#" class="third-btn job-btn2">full time</a>
                <a href="#" class="third-btn">apply</a>
              </div>
            </div>
          </div>
        </div>
        <div class="more-job-btn mt-5 text-center">
          <a href="#" class="template-btn">more job post</a>
        </div>
      </div>
    </section>
    <!-- Jobs Area End -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// JobSearch.vue?38781200